import type { FC } from 'react'

import { Checkbox } from '@skytech/ui'

const Category: FC<{
  id: number
  name: string
  counter: number
  selectedCategoryIds: number[] | null
  isSelected: boolean
  onCategorySelect: (categoryId: number, currentIdList: number[] | null) => void
}> = ({ id, name, counter, selectedCategoryIds, isSelected, onCategorySelect }) => (
  <div>
    <Checkbox
      id={`category-select-${name}`}
      checked={isSelected}
      label={`${name} (${counter})`}
      onChange={() => onCategorySelect(id, selectedCategoryIds)}
    />
  </div>
)

export default Category
